import { Box, Typography } from '@mui/material';
import ChatBubbleIcon from '@mui/icons-material/ChatBubble';
import iphoneFrame from '../../assets/iphone-noir-blanc-frame.png';

const SCREEN_INSET = { top: '5%', bottom: '1.2%', left: '10.7%', right: '10.7%' };
const FRAME_ASPECT_RATIO = '1016 / 1742';
const PHONE_WIDTH = { xs: 220, sm: 250, md: 270 };

const now = new Date();
const LOCK_SCREEN_DAY = now.toLocaleDateString('fr-FR', { weekday: 'long' });
const LOCK_SCREEN_TIME = now.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });

function SmsLockScreen({ message }: { message: string }) {
  return (
    <Box
      sx={{
        position: 'relative',
        flexShrink: 0,
        width: PHONE_WIDTH,
        aspectRatio: FRAME_ASPECT_RATIO,
        backgroundImage: `url(${iphoneFrame})`,
        backgroundSize: '100% 100%',
        backgroundRepeat: 'no-repeat',
        filter: 'drop-shadow(0 12px 30px rgba(0,0,0,0.25))',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          ...SCREEN_INSET,
          borderRadius: '8% / 4%',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          // Maquette d'écran verrouillé iPhone : couleurs littérales
          background: 'linear-gradient(180deg, #0f1c3f 0%, #1c2a4f 45%, #0a1228 100%)',
          px: 2,
          pt: 4,
        }}
      >
        <Typography sx={{ color: '#fff', fontSize: '0.85rem', textTransform: 'capitalize', opacity: 0.9 }}>
          {LOCK_SCREEN_DAY}
        </Typography>
        <Typography sx={{ color: '#fff', fontSize: '2.6rem', fontWeight: 300, lineHeight: 1.2 }}>
          {LOCK_SCREEN_TIME}
        </Typography>

        <Box sx={{ mt: 4, width: '100%', borderRadius: 3, backgroundColor: 'rgba(255,255,255,0.14)', backdropFilter: 'blur(6px)', p: 1.25 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mb: 0.5 }}>
            <ChatBubbleIcon sx={{ fontSize: '0.85rem', color: '#4caf50' }} />
            <Typography sx={{ color: '#fff', fontSize: '0.7rem', fontWeight: 700, flexGrow: 1 }}>
              MESSAGES
            </Typography>
            <Typography sx={{ color: 'rgba(255,255,255,0.6)', fontSize: '0.65rem' }}>
              maintenant
            </Typography>
          </Box>
          <Typography
            sx={{
              color: '#fff',
              fontSize: '0.78rem',
              lineHeight: 1.4,
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
              display: '-webkit-box',
              WebkitLineClamp: 4,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              opacity: message ? 1 : 0.5,
            }}
          >
            {message || 'Ecrivez votre message ci-dessous pour voir la notification…'}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}

export default SmsLockScreen;
